import { Trans } from '@lingui/macro';
import React from 'react';

import jobItemClasses from './JobItem.module.css';
import classes from './Legend.module.css';

const Legend: React.FC = () => {
    return (
        <div className={classes.legendContainer}>
            <div className={classes.legendItem}>
                <span
                    className={`${classes.dot} ${classes.first} ${jobItemClasses.firstBackground}`}
                ></span>{' '}
                <Trans>First</Trans>
            </div>
            <div className={classes.legendItem}>
                <span
                    className={`${classes.dot} ${jobItemClasses.repairBackground}`}
                ></span>{' '}
                <Trans>Repair</Trans>
            </div>
            {/* <div className={classes.legendItem}>
                <span
                    className={`${classes.dot} ${jobItemClasses.proBackground}`}
                ></span>{' '}
                <Trans>Pro</Trans>
            </div> */}
            <div className={classes.legendItem}>
                <span
                    className={`${classes.dot} ${jobItemClasses.uninstallBackground}`}
                ></span>{' '}
                <Trans>Uninstall</Trans>
            </div>
        </div>
    );
};

export default Legend;
